
import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LaunchButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link' | 'cta';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  children: React.ReactNode;
}

const LaunchButton = ({ 
  className, 
  variant = 'default', 
  size = 'default', 
  children,
  ...props 
}: LaunchButtonProps) => {
  const getButtonClass = () => {
    if (variant === 'cta') {
      return 'bg-gradient-to-r from-krix-purple to-krix-blue hover:from-krix-purple-dark hover:to-krix-blue-dark text-white font-medium shadow-md shadow-krix-purple/20 hover:shadow-lg hover:shadow-krix-purple/30 transition-all duration-300';
    }
    return '';
  };

  return (
    <Button
      className={cn(getButtonClass(), className)}
      variant={variant === 'cta' ? 'default' : variant}
      size={size}
      {...props}
    >
      {children}
    </Button>
  );
};

export default LaunchButton;
